import ColorPicker from '../ui/ColorPicker';
import type { ThemeColor } from '../../types/theme';

interface ThemeSelectorProps {
  currentColor: ThemeColor;
  onColorChange: (color: ThemeColor) => void;
}

function ThemeSelector({ currentColor, onColorChange }: ThemeSelectorProps) {
  return <ColorPicker currentColor={currentColor} onColorChange={onColorChange} />;
}

export default ThemeSelector;
